import { render, staticRenderFns } from "./addPlan.vue?vue&type=template&id=4771f9df&scoped=true&"
import script from "./addPlan.vue?vue&type=script&lang=js&"
export * from "./addPlan.vue?vue&type=script&lang=js&"
import style0 from "./addPlan.vue?vue&type=style&index=0&id=4771f9df&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4771f9df",
  null
  
)

export default component.exports